var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeiconnew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 1.75,
    fill: "#98A2B8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9064 7.96813L11.9072 7.96681C12.0492 7.74775 12.148 7.40086 12.148 7.00146C12.148 6.60207 12.0492 6.25518 11.9072 6.03612L11.9064 6.0348C10.6446 4.08113 8.86842 3.00029 7.00098 3.00029C5.13353 3.00029 3.3574 4.08113 2.09557 6.0348L2.09472 6.03612C1.95275 6.25518 1.85393 6.60207 1.85393 7.00146C1.85393 7.40086 1.95275 7.74775 2.09472 7.96681L2.09557 7.96813C3.3574 9.9218 5.13353 11.0026 7.00098 11.0026C8.86842 11.0026 10.6446 9.9218 11.9064 7.96813ZM12.5916 8.5699C11.1863 10.7458 9.16728 12.0029 7.00098 12.0029C4.83468 12.0029 2.81566 10.7458 1.41033 8.5699C0.858015 7.71769 0.858015 6.28524 1.41033 5.43303C2.81566 3.25717 4.83468 2 7.00098 2C9.16728 2 11.1863 3.25717 12.5916 5.43303C13.1439 6.28524 13.1439 7.71769 12.5916 8.5699Z",
    fill: "#98A2B8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeiconnew);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/eye.icon.new.3f52106b4120256c9ff9dd32c6a935ef.svg";
export { ForwardRef as ReactComponent };